export const GET_DOWNLOAD_CONFIRMATION_QUERY_KEY = 'GET_DOWNLOAD_CONFIRMATION_QUERY_KEY';